import { SModalEditAuthorizationList } from '@styled/admin/authorizationListPage/authorizationList';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import Input from 'components/bases/shared/input';
import Button from 'components/bases/shared/button';
import inputIcons from 'components/bases/shared/icons/input';
import { useSelector, useDispatch } from 'react-redux';
import {
  getUserApi,
  setChooseList,
} from '@duck/pages/admin/authorizationListReducer/actions';
import { VALIDATE_REQUIRE } from '@constants/validate';
import ErrorMessage from '@components/input/ErrorMessage';
import { callApi } from '@state-common/';
import { URL_EDIT } from '@duck/pages/admin/authorizationListReducer/constants';
import PNotify from 'pnotify/dist/es/PNotify';
import { handleError } from '@configs/handleError';
import { useTranslation } from 'react-i18next';

export const EditModal = ({ setToggleModal }) => {
  const { t } = useTranslation();
  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  const { listChose, filter } = useSelector(
    (state) => state.admin.authorizationList,
  );
  const [allFiles, setAllFiles] = useState([]);
  const [removeFiles, setRemoveFiles] = useState([]);

  const onSubmit = (data) => {
    const { name, phone, email, address, password } = data;
    const temp = listChose[0];

    // Prepare form data to handle both files and text fields
    const formData = new FormData();
    formData.append('name', name);
    formData.append('phone', phone);
    if (email && email !== '') formData.append('email', email);
    if (address && address !== '') formData.append('address', address);
    if (password) formData.append('password', password);

    // Append only newly uploaded files (binary)
    allFiles.forEach((item) => {
      if (item.file) {
        formData.append('files', item.file);
      }
    });

    // Append removed files as JSON
    if (removeFiles.length > 0) {
      formData.append('removeFiles', JSON.stringify(removeFiles));
    }

    callApi(`${URL_EDIT}/${temp._id}`, 'POST', formData)
      .then(function (res) {
        setToggleModal(false);
        setTimeout(() => {
          dispatch(getUserApi(filter));
          dispatch(setChooseList([]));
        }, 500);
        PNotify.success({
          title: t('Thành công'),
          text: t('Sửa thành công'),
          destroy: true,
          delay: 2000,
        });
      })
      .catch(handleError);
  };
  useEffect(() => {
    // Load existing files from server
    const initialFiles = [];
    if (listChose[0]?.files && Array.isArray(listChose[0].files)) {
      initialFiles.push(
        ...listChose[0].files.map((url) => ({
          file: null,
          url: url,
          name: url.split('/').pop(),
        })),
      );
    }
    setAllFiles(initialFiles);
    setRemoveFiles([]);

    setValue('identityNumber', listChose[0] ? listChose[0].identityNumber : '');
    setValue('name', listChose[0] ? listChose[0].name : '');
    setValue('phone', listChose[0] ? listChose[0].phone : '');
    setValue('email', listChose[0] ? listChose[0].email : '');
    setValue('address', listChose[0] ? listChose[0].address : '');
    setValue('sharesNumber', listChose[0] ? listChose[0].sharesNumber : '');
  }, [listChose, setValue]);

  const handleFileUpload = (event) => {
    const selectedFiles = Array.from(event.target.files || []);
    // Get all existing file names
    const existingFileNames = allFiles.map((item) => item.name);

    const newFiles = selectedFiles.filter((file) => {
      const isNotDuplicate = !existingFileNames.includes(file.name);
      if (!isNotDuplicate) {
        PNotify.error({
          title: t('Lỗi'),
          text: t(
            `File ${file.name} đã tồn tại. Vui lòng xóa file trước khi tải lại.`,
          ),
          destroy: true,
          delay: 2000,
        });

        return false;
      }
      return true;
    });

    setAllFiles((prevFiles) => [
      ...prevFiles,
      ...newFiles.map((file) => ({
        file: file,
        url: null,
        name: file.name,
      })),
    ]);
    if (newFiles.length > 0)
      PNotify.success({
        title: t('Thành công'),
        text: t('Tải file thành công'),
        destroy: true,
        delay: 2000,
      });
  };

  const removeFile = (item) => {
    // Remove from allFiles
    setAllFiles((prevFiles) =>
      prevFiles.filter((file) => file.name !== item.name),
    );

    // If it's an existing file (has url), add to removeFiles
    if (item.url) {
      setRemoveFiles((prevRemove) => [...prevRemove, item.url]);
    }
  };
  return (
    <SModalEditAuthorizationList>
      <div className="handle-wrapper">
        <div className="handle-item width-50">
          <Input.Text
            inputProps={{
              readOnly: true,
            }}
            register={register('identityNumber')}
            readOnly
            wrapperProps={{
              label: t('CMND/CCCD (Tài khoản)'),
              icon: inputIcons.code,
              //   required: true,
            }}
          />
          <ErrorMessage errors={errors} field="identityNumber" />
        </div>
        <div className="handle-item width-50">
          <Input.Text
            register={register('name', { required: t(VALIDATE_REQUIRE) })}
            wrapperProps={{
              label: t('Họ tên người được ủy quyền'),
              icon: inputIcons.account,
              //   required: true,
            }}
          />
          <ErrorMessage errors={errors} field="name" />
        </div>
        <div className="handle-item width-50">
          <Input.Text
            inputProps={{
              type: 'number',
            }}
            register={register('phone', { required: t(VALIDATE_REQUIRE) })}
            wrapperProps={{
              label: t('Số điện thoại'),
              icon: inputIcons.phone,
              //   required: true,
            }}
          />
          <ErrorMessage errors={errors} field="name" />
        </div>
        <div className="handle-item width-50">
          <Input.Text
            register={register('email')}
            wrapperProps={{
              label: 'Email',
              icon: inputIcons.email,
              //   required: true,
            }}
          />
        </div>
        <div className="handle-item width-100">
          <Input.Text
            register={register('address')}
            wrapperProps={{
              label: t('Địa chỉ'),
              icon: inputIcons.address,
              //   required: true,
            }}
          />
        </div>
        <div className="handle-item width-50">
          <Input.Text
            inputProps={{
              readOnly: true,
            }}
            register={register('sharesNumber', {
              required: t(VALIDATE_REQUIRE),
            })}
            readOnly
            wrapperProps={{
              label: t('Số CP được ủy quyền'),
              icon: inputIcons.file,
              //   required: true,
            }}
          />
          <ErrorMessage errors={errors} field="sharesNumber" />
        </div>
        <div className="handle-item width-50">
          <Input.Text
            register={register('password')}
            wrapperProps={{
              label: t('Đặt lại mật khẩu'),
              icon: inputIcons.code,
              //   required: true,
            }}
          />
          {/* <ErrorMessage errors={errors} field="password" /> */}
        </div>
        {allFiles.length > 0 ? (
          <div className="choose-file">
            <div className="filenames">
              {allFiles.map((item) => (
                <div key={item.name} className="file-preview">
                  <img
                    src={item.file ? URL.createObjectURL(item.file) : item.url}
                    alt={item.name}
                  />
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      removeFile(item);
                    }}
                  >
                    x
                  </span>
                </div>
              ))}
            </div>
            <label className="action">
              <span className="icon">
                <UploadIcon />
              </span>
              <input
                type="file"
                onChange={handleFileUpload}
                multiple
                className="input-file"
              />
            </label>
          </div>
        ) : (
          <button className="import__btn" type="button">
            <label>
              <span className="file-custom">
                <div className="wrap">
                  <span className="icon">
                    <UploadIconMax />
                  </span>
                  {t('Tải lên giấy ủy quyền')}
                </div>
              </span>
              <input
                type="file"
                onChange={handleFileUpload}
                multiple
                className="input-file"
              />
            </label>
            <div className="img_upload2">
              <UploadIcon />
            </div>
          </button>
        )}
      </div>
      <div className="button-group">
        <Button className="cancel-button" onClick={() => setToggleModal(false)}>
          {t('Hủy bỏ')}
        </Button>
        <Button onClick={handleSubmit(onSubmit)} className="confirm-button">
          {t('Cập nhật')}
        </Button>
      </div>
    </SModalEditAuthorizationList>
  );
};

export const UploadIconMax = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M42.4825 52.1729H13.517C13.0048 52.1729 12.5137 51.9695 12.1515 51.6073C11.7894 51.2452 11.5859 50.754 11.5859 50.2419V21.2764C11.5859 20.7642 11.7894 20.2731 12.1515 19.9109C12.5137 19.5488 13.0048 19.3453 13.517 19.3453H22.2066C22.7188 19.3453 23.2099 19.5488 23.5721 19.9109C23.9342 20.2731 24.1377 20.7642 24.1377 21.2764C24.1377 21.7885 23.9342 22.2797 23.5721 22.6418C23.2099 23.004 22.7188 23.2074 22.2066 23.2074H15.448V48.3108H40.5515V23.2074H33.7928C33.2807 23.2074 32.7895 23.004 32.4274 22.6418C32.0652 22.2797 31.8618 21.7885 31.8618 21.2764C31.8618 20.7642 32.0652 20.2731 32.4274 19.9109C32.7895 19.5488 33.2807 19.3453 33.7928 19.3453H42.4825C42.9946 19.3453 43.4858 19.5488 43.8479 19.9109C44.2101 20.2731 44.4135 20.7642 44.4135 21.2764V50.2419C44.4135 50.754 44.2101 51.2452 43.8479 51.6073C43.4858 51.9695 42.9946 52.1729 42.4825 52.1729ZM34.8279 14.5177C34.5743 14.518 34.3231 14.4682 34.0888 14.3711C33.8545 14.274 33.6417 14.1315 33.4626 13.952L27.9997 8.48905L22.5368 13.95C22.1747 14.3121 21.6837 14.5155 21.1716 14.5155C20.6595 14.5155 20.1684 14.3121 19.8064 13.95C19.4443 13.5879 19.2409 13.0968 19.2409 12.5848C19.2409 12.0727 19.4443 11.5816 19.8064 11.2195L26.6345 4.39333C26.8137 4.21385 27.0265 4.07146 27.2607 3.97431C27.495 3.87715 27.7461 3.82715 27.9997 3.82715C28.2533 3.82715 28.5045 3.87715 28.7387 3.97431C28.973 4.07146 29.1858 4.21385 29.365 4.39333L36.1931 11.2195C36.4647 11.4891 36.65 11.8334 36.7254 12.2086C36.8008 12.5838 36.7629 12.9729 36.6165 13.3265C36.4702 13.68 36.2219 13.9821 35.9034 14.1942C35.5849 14.4064 35.2105 14.519 34.8279 14.5177Z"
      fill="#9AB1CC"
    />
    <path
      d="M28.0004 34.7936C27.4882 34.7936 26.9971 34.5902 26.6349 34.2281C26.2728 33.8659 26.0693 33.3748 26.0693 32.8626V7.75916C26.0693 7.24702 26.2728 6.75585 26.6349 6.39371C26.9971 6.03157 27.4882 5.82813 28.0004 5.82812C28.5125 5.82813 29.0037 6.03157 29.3658 6.39371C29.728 6.75585 29.9314 7.24702 29.9314 7.75916V32.8626C29.9314 33.3748 29.728 33.8659 29.3658 34.2281C29.0037 34.5902 28.5125 34.7936 28.0004 34.7936Z"
      fill="#9AB1CC"
    />
  </svg>
);

export const UploadIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill="#00CB82" />
      <g clipPath="url(#clip0_136_6245)">
        <path
          d="M15.2066 12.796L15.2258 18.4016H16.7514L16.7898 12.7904L18.801 14.8016L20.001 13.6016L16.001 9.60156L12.001 13.6016L13.201 14.8016L15.2066 12.796Z"
          fill="white"
        />
        <path
          d="M20.8006 17.6016V20.0016H11.2006V17.6016H9.60059V22.4016H22.4006V17.6016H20.8006Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_136_6245">
          <rect
            width="12.8"
            height="12.8"
            fill="white"
            transform="translate(9.60059 9.60156)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
